import React from "react";
import { Avatar, Box, List, ListItem, ListItemIcon, Stack, Typography, Skeleton } from "@mui/material";

const AppointmentClientDetailSkeleton = () => {
  const skeletonItems = [1, 2, 3]; // Placeholder array for list items

  return (
    <Stack p={2} gap={1.5} alignItems={"center"} textAlign={"center"}>
      {/* Title Skeleton */}
      <Skeleton variant="text" width={150} height={30} />
      {/* Avatar Skeleton */}
      <Skeleton variant="circular" width={100} height={100} />
      <Box>
        {/* Username Skeleton */}
        <Skeleton variant="text" width={120} height={20} />
        {/* Address Skeleton */}
        <Skeleton variant="text" width={200} height={15} />
        <List sx={{ mt: 1 }}>
          {skeletonItems.map((_, index) => (
            <ListItem key={index} sx={{ py: "2px" }}>
              <ListItemIcon sx={{ minWidth: 30 }}>
                <Skeleton variant="circular" width={20} height={20} />
              </ListItemIcon>
              <Skeleton variant="text" width={150} height={15} />
            </ListItem>
          ))}
        </List>
        {/* Button Skeleton */}
        <Skeleton variant="rectangular" width={180} height={40} sx={{ mt: 1 }} />
      </Box>
    </Stack>
  );
};

export default AppointmentClientDetailSkeleton;
